import I18n from 'lib/i18n'
import isEmailValid from 'lib/utils/is-email-valid'
import GraphemeSplitter from 'grapheme-splitter'

const splitter = new GraphemeSplitter()

export const stringLength = text => (text || '').replace(/([\W])(?=\1)/gi, '').trim().length

export const arrayLength = arr => {
  let start = 0
  let end = arr.length - 1
  while (start < end && arr[start] === '') {
    start++
  }
  while (end > start && arr[end] === '') {
    end--
  }
  return arr.slice(start, end + 1).length
}

export const requireBookingTime = value => {
  if (value.length) {
    if (value.filter(bt => bt.isEditing).length) {
      return ' '
    } else {
      return null
    }
  } else {
    return I18n.t('courses.form.error_field_empty')
  }
}
export const requiredLocation = (locationId, locations) => {
  if (locations.filter(l => l.id === locationId).length) {
    return isNaN(locationId) || !locationId ? I18n.t('courses.form.error_field_empty') : null
  }
  return I18n.t('courses.form.error_field_empty')
}
export const requiredStudentAddress = (locations, locationId, studentAddress) => {
  if (locationId) {
    const selectedLocation = locations.filter(l => l.id === locationId)
    const selectedLocationType = selectedLocation.length ? selectedLocation[0].locationType : null
    return selectedLocationType === 'in_house' ? required(studentAddress) : null
  }
  return null
}

export const requiredPhone = (phone, phoneValid) => {
  const phoneError = required(phone)
  return !phoneError && !phoneValid ? I18n.t('errors.invalid_phone_number') : phoneError
}

export const requiredPaymentMethod = (paymentMethod, useCredit, selectedTotalPrice, creditAvailable) => {
  if (useCredit) {
    const isEnoughToPay = creditAvailable - selectedTotalPrice >= 0
    return isEnoughToPay ? null : required(paymentMethod)
  } else {
    return required(paymentMethod)
  }
}

export const required = value => (stringLength(value) === 0 ? I18n.t('courses.form.error_field_empty') : null)
export const requiredFullName = value =>
  required(value) || value.trim().split(' ').length < 2
    ? I18n.t('devise.sessions.new_student.error_no_full_name')
    : null
export const requiredArray = value => (value.length === 0 ? I18n.t('courses.form.error_field_empty') : null)

export const requiredLength = (value, length) => {
  const graphemeClustersString = splitter.splitGraphemes(value || '')
  const stringLength = arrayLength(graphemeClustersString)
  return stringLength < length ? I18n.t('errors.not_long_enough', { count: length - stringLength }) : null
}

export const requiredEmail = value =>
  stringLength(value) === 0
    ? I18n.t('courses.form.error_field_empty')
    : !isEmailValid(value.trim())
    ? I18n.t('courses.show_share.email_error_not_email')
    : null
